const config = {
  DEV:{
    baseUrl:'http://localhost:3102/',
  },
  PROD:{
    baseUrl:'https://taodi.fun/taodi/',
  }
}

module.exports = config.PROD



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1